import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ILoginModal {
  isOpen: boolean;
}

const initialState: ILoginModal = {
  isOpen: false,
};

const loginModalSlice = createSlice({
  name: 'loginModal',
  initialState: initialState,
  reducers: {
    open: (state) => {
      state.isOpen = true;
    },
    close: (state) => {
      state.isOpen = false;
    },
    openCloseLoginModal: (
      state,
      action: PayloadAction<boolean | undefined>
    ) => {
      state.isOpen = action.payload !== undefined ? action.payload : true;
    },
  },
});

export const { open, close, openCloseLoginModal } = loginModalSlice.actions;

export default loginModalSlice.reducer;
